import Button from "@mui/material/Button";
import { useMattoState } from "../../../MattoState";

const notify = (message: string, action?: React.ReactNode) =>
  useMattoState.getState().setSnackbarMessage(message, true, action);

const runUndo = async (undo: () => Promise<void> | void, undone: string) => {
  try {
    await undo();
    notify(undone);
  } catch (e: any) {
    notify(e?.message || "Couldn't undo that.");
  }
};

/**
 * Run a reversible mutation and offer Undo in the snackbar's action slot.
 *
 * This is the recovery path for archiving from the project Recent grid (#3792):
 * archived boards are only reachable from the *unscoped* board list, and
 * archived concepts and schedules have no view at all, so an in-the-moment Undo
 * is what keeps an accidental archive from being a dead end (#3523).
 */
export const runUndoable = async ({
  act,
  undo,
  done,
  undone,
  failed,
}: {
  act: () => Promise<void>;
  undo: () => Promise<void>;
  /** Snackbar text on success — carries the Undo button. */
  done: string;
  /** Snackbar text once Undo has completed. */
  undone: string;
  /** Fallback text when `act` throws without a message. */
  failed: string;
}) => {
  try {
    await act();
    notify(
      done,
      <Button
        color="secondary"
        size="small"
        onClick={() => void runUndo(undo, undone)}
      >
        UNDO
      </Button>,
    );
  } catch (e: any) {
    notify(e?.message || failed);
  }
};
